var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
import { invalidMaterialWithGas, } from "../utilities/articleeditdata";
import { objEq, } from "../utilities/aux";
import { createString, isLaserMaterialMapEntry, isValid, laserMaterialMap, } from "../utilities/material";
let MaterialElement = class MaterialElement extends Vue {
    constructor() {
        super(...arguments);
        this.currentIndex = 0;
    }
    onChange(event) {
        this.currentIndex = event.target.selectedIndex;
        return this.materialsWithGas[this.currentIndex];
    }
    initialChange() { return this.materialsWithGas[this.currentIndex]; }
    createString(m) {
        if (m.cuttingGasId === "") {
            return m.material.identifier;
        }
        return createString(m, this.i18n);
    }
    description(m) { return m.invalid ? (m.cuttingGasId === "" ? this.invalidEntry.material.description : this.i18n.t("materialSelectionInvalid")) : m.material.description; }
    initialize() {
        this.currentIndex = this.materialsWithGas.findIndex(m => m.material.identifier === this.value.material.identifier && m.cuttingGasId === this.value.cuttingGasId);
        if (this.currentIndex === -1) {
            this.currentIndex = 0;
        }
        this.initialChange();
    }
    materialGroupDisabled(l) {
        if (!isLaserMaterialMapEntry(l)) {
            throw Error("Wrong type.");
        }
        return l.materials.every(m => m.invalid);
    }
    get elementKey() { return "materialWithGas"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    get laserMaterialMap() { return laserMaterialMap(this.shopConfig, (m) => !isValid(this.shopConfig, this.thicknesses, m.material.identifier, m.cuttingGasId)); }
    get invalidEntry() {
        return invalidMaterialWithGas(this.i18n);
    }
    get materialsWithGas() {
        return [
            this.invalidEntry,
            ...this.laserMaterialMap.reduce((res, entry) => [
                ...res,
                ...entry.materials,
            ], []),
        ];
    }
    get currentMaterial() { return this.materialsWithGas[this.currentIndex]; }
    created() {
        this.initialize();
    }
    onValueChanged() {
        if (!objEq(this.value, this.currentMaterial)) {
            this.initialize();
        }
    }
};
__decorate([
    Prop({ required: true })
], MaterialElement.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], MaterialElement.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], MaterialElement.prototype, "thicknesses", void 0);
__decorate([
    Prop({ required: true })
], MaterialElement.prototype, "value", void 0);
__decorate([
    Inject()
], MaterialElement.prototype, "networkBroker", void 0);
__decorate([
    Inject()
], MaterialElement.prototype, "i18n", void 0);
__decorate([
    Emit("input")
], MaterialElement.prototype, "onChange", null);
__decorate([
    Emit("input")
], MaterialElement.prototype, "initialChange", null);
__decorate([
    Watch("value")
], MaterialElement.prototype, "onValueChanged", null);
MaterialElement = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "MaterialElement",
    })
], MaterialElement);
export default MaterialElement;
